import * as v from 'valibot';

import { maoLocationSchema } from './maoLocation.schema';

import type { MaoAircraft } from '../types';

export const maoAircraftSchema = v.object({
  Location: maoLocationSchema,
  Id: v.number('Aircraft ID is missing'),
  Registration: v.string('Aircraft registration is missing'),
}) satisfies v.GenericSchema<MaoAircraft>;
